import React from 'react';

import { styled } from '../theme';

const StyledPageContainer = styled('div')<{ centered?: boolean }>(({ centered }) => ({
    display: 'flex',
    flexFlow: 'column',
    flexGrow: 1,
    height: '100%',
    position: 'relative',
    alignItems: centered ? 'center' : 'flex-start',
}));

const PageContainer: React.FC<{ centered?: boolean; children?: React.ReactNode }> = ({
    centered,
    children,
    ...props
}) => (
    <StyledPageContainer data-testid="page-container" centered={centered} {...props}>
        {children}
    </StyledPageContainer>
);

export default PageContainer;
